/* eslint-disable no-new */
import Stands from './Stands';
import Sponsorships from './Sponsorships';
import Registration from './Registration';

class MainExhibitors {
    constructor() {
        new Stands();
        new Sponsorships();
        new Registration();

        // Seminar block
        this.blockSeminar = document.querySelector('.block-seminar');
        if (this.blockSeminar) {
            this.contentYes = this.blockSeminar.querySelector('.block-content-yes');
            this.bindChoiceSeminar();
            this.blockSeminar.querySelectorAll('input[name="seminar_registration"]').forEach((item) => {
                item.addEventListener('click', () => {
                    this.bindChoiceSeminar();
                });
            });
        }

        this.buttonClose = document.querySelector('.button-welcome-close');
        this.buttonOpen = document.querySelector('.button-welcome-open');
        this.welcomeBloc = document.querySelector('#welcome-bloc');
        if (this.welcomeBloc && this.buttonOpen && this.buttonClose) {
            // if (localStorage.getItem('openWelcomeExhibitor')) {
            //     if (parseInt(localStorage.getItem('openWelcomeExhibitor'), 10) === 0) {
            //         this.closeWelcomeExhibitor();
            //     } else {
            //         this.openWelcomeExhibitor();
            //     }
            // }
            this.buttonOpen.addEventListener('click', () => {
                this.openWelcomeExhibitor();
            });
            this.buttonClose.addEventListener('click', () => {
                this.closeWelcomeExhibitor();
            });
        }
    }

    bindChoiceSeminar() {
        this.contentYes.classList.add('hidden');
        const choiceSeminar = this.blockSeminar.querySelector('input[name="seminar_registration"][value="Yes"]');
        if (choiceSeminar.checked) {
            this.contentYes.classList.remove('hidden');
        }
    }

    openWelcomeExhibitor() {
        this.welcomeBloc.classList.remove('hide');
        this.buttonOpen.classList.add('hide');
        this.buttonClose.classList.remove('hide');
        localStorage.setItem('openWelcomeExhibitor', 1);
    }

    closeWelcomeExhibitor() {
        this.welcomeBloc.classList.add('hide');
        this.buttonClose.classList.add('hide');
        this.buttonOpen.classList.remove('hide');
        localStorage.setItem('openWelcomeExhibitor', 0);
    }
}

export default MainExhibitors;
